import { Versions } from '../constants/versions';
import { Utils } from '../utils';

export interface IInteractionComponent {
	id?: string;
	description?: { [key: string]: any };
}

export interface InteractionComponentParams {
	id?: string;
	description?: { [key: string]: any };
}

export class InteractionComponent {
	id?: string;
	description?: { [key: string]: any };

	constructor(cfg: InteractionComponentParams = {}) {
		const { id, description } = cfg;
		this.id = id;
		this.description = description;
	}

	asVersion(version: Versions = '1.0.3'): IInteractionComponent {
		const result: IInteractionComponent = {
			id: this.id,
			description: this.description
		};

		return result;
	}

	getLangDictionaryValue = Utils.getLangDictionaryValue;

	static fromJSON(icJSON: string): InteractionComponent {
		const _ic = JSON.parse(icJSON);

		return new InteractionComponent(_ic);
	}
}
